module.exports = __webpack_public_path__ + "static/media/error403.d88d2205.svg";